<template>
  <v-hover v-slot:default="{ hover }">
    <v-card
      class="pa-7 custom-card d-flex flex-column half-radius shadow"
      :class="{ 'custom-card-active': hover }"
    >
      <div
        class="mark-completed circle"
        :class="{ bordered: isTeacher && !progress.completed, rotating: loading }"
      >
        <v-tooltip top v-if="isTeacher">
          <template #activator="{ on }">
            <v-img
              src="./../../../assets/completed.svg"
              contain
              class="invisible"
              :class="{ hover: isTeacher, visible: !isTeacher || progress.completed }"
              v-on="on"
              @click="onClick"
            />
          </template>
          <span>{{ progress.completed ? "Unmark" : "Mark" }} module as completed</span>
        </v-tooltip>
        <v-img v-else-if="progress.completed" src="./../../../assets/completed.svg" contain />
      </div>

      <div class="card-container-image d-flex justify-center align-center">
        <v-img contain :src="item.image" height="90"></v-img>
      </div>

      <p class="text-start color-262626 font-weight-regular headline mt-5 mb-0">{{ item.name }}</p>

      <p class="text-start color-29284C font-weight-regular caption">
        Total Lessons: {{ item.lessons ? item.lessons.length : 0 }}
      </p>

      <v-spacer></v-spacer>
      <v-row>
        <v-col>
          <v-btn
            @click="goModule"
            depressed
            small
            class="text-capitalize caption pr-3 white--text"
            color="#FF347C"
            >Go to lessons</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
  </v-hover>
</template>

<script>
import studentMixin from "@/mixins/studentMixin";
import { getModuleProgress, postModuleProgress, patchModuleProgress } from "@/api/api";

export default {
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  mixins: [studentMixin],
  data() {
    return {
      progress: {},
      loading: false,
    };
  },
  methods: {
    goModule() {
      if (!this.$store.getters.student && this.$store.getters.profile.role !== "STUDENT") {
        this.$store.commit("studentDialog", true);
        return;
      }
      window.location.assign(`/app/modules/${this.item.uuid}/lessons`);
    },
    async getInitialData() {
      if (this.student) {
        const response = await getModuleProgress({
          module__uuid: this.item.uuid,
          student__email: this.student.email,
        });
        if (response.data.count) {
          [this.progress] = response.data.results;
        } else {
          const modResponse = await postModuleProgress({
            module__uuid: this.item.uuid,
            student__email: this.student.email,
          });
          if (modResponse) {
            this.progress = modResponse.data;
          }
        }
      }
    },
    async onClick() {
      if (this.isTeacher) {
        this.loading = true;
        let body = {
          uuid: this.progress.uuid,
          completed: !this.progress.completed,
        };
        const response = await patchModuleProgress(body);
        if (response) {
          this.progress.completed = !this.progress.completed;
        }
        this.loading = false;
      }
    },
  },
  created() {
    this.getInitialData();
  },
};
</script>
<style scoped>
.mark-completed {
  max-height: 26px;
  position: absolute;
  right: 36px;
  top: 36px;
  z-index: 1;
}
.custom-card {
  text-align: center;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #0000001a;
  height: 331px;
}
.card-container-image {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #29274d;
  border-radius: 10px !important;
  height: 104px;
  overflow: hidden;
}
.invisible {
  opacity: 0;
  transition: opacity 0.2s linear;
}
.invisible:hover {
  opacity: 1;
}
.visible {
  opacity: 1;
}
.bordered {
  border: 1px #29284c dashed;
  transition: border 0.2s linear;
}
.bordered:hover {
  border: 1px transparent dashed;
}
</style>
